import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore, PreloadedState } from '@reduxjs/toolkit';

import { rootReducer } from '@store/reducer';

export type TRootState = ReturnType<typeof rootReducer>;
export type TAppDispatch = TAppStore['dispatch'];

export function setupStore(preloadedState: PreloadedState<TRootState> = {}, isDevTools = true) {
	return configureStore({
		reducer: rootReducer,
		preloadedState,
		devTools: isDevTools,
		middleware: getDefaultMiddleware => getDefaultMiddleware({
			thunk: true,
		}),
	});
}

export const store = setupStore();

export const useAppDispatch = () => useDispatch<TAppDispatch>();
export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
export type TAppStore = ReturnType<typeof setupStore>
